<template>
    <div>
        <div class="header mt-8">
            <div class="text-header">
                {{ $vuetify.lang.t('$vuetify.attendanceForm.updateAttendance') }}
            </div>
            <div v-if="employeeActive">
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.attendanceForm.cancel') }}
                </v-btn>

                <v-btn
                    @click="submit()"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.attendanceForm.save') }}
                </v-btn>
            </div>
            <div v-else>
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    width="150"
                    color="primary">
                    Close
                </v-btn>
            </div>
        </div>
        <div class="attendance-form-container locale-font">
            <v-card class="attendance-profile content-container">
                <v-container class="pa-attendance-review">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.attendanceForm.profile') }}
                    </v-row>
                    <v-row>
                        <v-col cols="3" class="pt-0 profile-container">
                            <profile :img="form.employeeImg"  />
                        </v-col>
                        <v-col cols="9" class="pt-0">
                            <v-row>
                                <v-col cols="12">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.attendanceForm.name') }}
                                    </div>
                                    <div class="form-text text-ellipsis-12">{{ form.employeeFullname }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.attendanceForm.group') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.groupName }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.attendanceForm.department') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.departmentName }}</div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-card class="attendance-status content-container" :disabled="!employeeActive">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>
                    <v-container class="pa-attendance-review">
                        <div class="status-card-header">
                            <div>
                                {{ $vuetify.lang.t('$vuetify.attendanceForm.department') }}
                            </div>
                            <div class="date-data">
                                {{ $vuetify.lang.t('$vuetify.attendanceForm.date') }}: {{form.date}}
                            </div>
                        </div>
                        <v-row class="mx-5 time-input-container">
                            <v-col cols="6">
                                <v-text-field
                                    v-if="form.status != 'ABS'"
                                    v-model="form.checkIn"
                                    autocomplete="off"
                                    :label="$vuetify.lang.t('$vuetify.attendanceForm.checkIn')"
                                    type="time"
                                    ref="checkIn"
                                    :rules="ruleCheckin"
                                    placeholder=""
                                    :error-messages="messageErrorCheckin"
                                    @change="changeTime()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="form.date != form.today">
                                <v-text-field
                                    v-if="form.status != 'ABS'"
                                    v-model="form.checkOut"
                                    autocomplete="off"
                                    :label="$vuetify.lang.t('$vuetify.attendanceForm.checkOut')"
                                    type="time"
                                    ref="checkOut"
                                    :rules="ruleCheckout"
                                    placeholder=""
                                    :error-messages="messageErrorCheckout"
                                    @change="changeTime()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12" class="text-center">
                                <div class="choices-container">
                                    <div :class="choiceClass(form.status, 'PRS')" @click="clickStatus('PRS')">{{ $vuetify.lang.t('$vuetify.attendanceForm.ontime') }}</div>
                                    <div :class="choiceClass(form.status, 'LAT')" @click="clickStatus('LAT')">{{ $vuetify.lang.t('$vuetify.attendanceForm.late') }}</div>
                                    <div :class="choiceClass(form.status, 'ABS')" @click="clickStatus('ABS')">{{ $vuetify.lang.t('$vuetify.attendanceForm.absent') }}</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card>
            <v-card class="attendance-log content-container">
                <v-container class="pa-attendance-review">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.attendanceForm.activityLog') }}
                    </v-row>
                    <div v-if="log.length > 0"
                        class="custom-scrollbar" >
                        <v-timeline
                            align-top
                            dense
                        >
                            <v-timeline-item
                                v-for="itemLog in log"
                                :key="itemLog.actorId"
                                small>
                                    {{itemLog.description}}<br>
                                    {{itemLog.date}} {{itemLog.time}}
                            </v-timeline-item>
                        </v-timeline>
                    </div>
                    <div v-if="log.length === 0">
                        <div class="no-data">
                            {{ $vuetify.lang.t('$vuetify.attendanceForm.thereIsNoActivityLog')}}
                        </div>
                    </div>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
import Profile from '@/components/Profile'
import imgPath from '@/assets/user_default.png'
export default {
    name: 'AttendanceForm',

    components: {
        Profile
    },

    computed: {
        baseChoiceClass () {
            if (this.loading) {
                return 'choice disable'
            }

            return 'choice'
        },

        ruleCheckin () {
            if (this.form.status === 'LAT') {
                return [
                    value => !!value || this.$vuetify.lang.t('$vuetify.attendanceForm.thisFieldIsRequired'),
                    value => (this.form.startTime < this.form.checkIn && this.form.checkIn <= this.form.endTime) || `${this.$vuetify.lang.t('$vuetify.attendanceForm.seletePeriod')} ${this.form.startTime} - ${this.form.endTime}.`
                ]
            } else if (this.form.status === 'PRS') {
                return [
                    value => !!value || this.$vuetify.lang.t('$vuetify.attendanceForm.thisFieldIsRequired'),
                    value => !(this.form.startTime < this.form.checkIn) || `${this.$vuetify.lang.t('$vuetify.attendanceForm.seleteBefore')} ${this.form.startTime}.`
                ]
            } else {
                return [
                    value => !!value || this.$vuetify.lang.t('$vuetify.attendanceForm.thisFieldIsRequired')
                ]
            }
        },

        ruleCheckout () {
            return [
                value => !!value || this.$vuetify.lang.t('$vuetify.attendanceForm.thisFieldIsRequired')
            ]
        }
    },

    data () {
        return {
            form: {
                employeeFullname: '',
                employeeImg: '',
                groupName: '',
                departmentName: '',
                status: '',
                date: '',
                today: '',
                checkIn: '',
                checkOut: '',
                startTime: '',
                endTime: ''
            },
            attendanceId: null,
            valid: true,
            messageErrorCheckin: null,
            messageErrorCheckout: null,
            log: [],
            employeeActive: true
        }
    },

    methods: {
        async loadData (id) {
            this.$store.dispatch('setLoading', true)
            const url = `attendance/detail/${id}`
            const res = await this.axios.get(url)

            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                const data = res.data.data
                this.form = {
                    employeeFullname: data.employeeFullname,
                    groupName: data.groupName,
                    departmentName: data.departmentName,
                    status: data.attendanceStatus,
                    date: data.attendanceDate,
                    checkIn: data.checkinTime,
                    checkOut: data.checkoutTime,
                    startTime: data.startTime,
                    endTime: data.endTime,
                    today: data.today,
                    employeeImg: imgPath
                }

                this.employeeActive = data.employeeActive

                if (data.employeeImg !== null) {
                    this.form.employeeImg = data.employeeImg
                }

                this.log = res.data.log
            } else {
                this.cancel()
            }
        },

        async clickStatus (status) {
            this.$refs.form.resetValidation()
            this.form.status = status
            await this.changeTime()
        },

        async changeTime () {
            if (this.form.status !== 'ABS' && this.form.checkIn !== '') {
                if (this.form.status === 'LAT') {
                    if (this.form.startTime < this.form.checkIn && this.form.checkIn <= this.form.endTime) {
                        this.valid = true
                        this.messageErrorCheckin = ''
                    } else {
                        this.valid = false
                        this.messageErrorCheckin = `${this.$vuetify.lang.t('$vuetify.attendanceForm.seletePeriod')} ${this.form.startTime} - ${this.form.endTime}.`
                        this.$notify({
                            title: this.$vuetify.lang.t('$vuetify.attendanceForm.errorTime'),
                            text: this.messageErrorCheckin,
                            type: 'error'
                        })
                    }
                } else if (this.form.status === 'PRS') {
                    if (this.form.startTime >= this.form.checkIn) {
                        this.valid = true
                        this.messageErrorCheckin = ''
                    } else {
                        this.valid = false
                        this.messageErrorCheckin = `${this.$vuetify.lang.t('$vuetify.attendanceForm.seleteBefore')} ${this.form.startTime}.`
                        this.$notify({
                            title: this.$vuetify.lang.t('$vuetify.attendanceForm.errorSeleteTime'),
                            text: this.messageErrorCheckin,
                            type: 'error'
                        })
                    }
                }
            } else {
                this.valid = true
                this.messageErrorCheckin = ''
                this.messageErrorCheckout = ''
            }
        },

        cancel () {
            this.$router.push({ path: '/inquiry-and-attendance/manage-attendance' }, () => {})
        },

        async updateAttendance () {
            this.$store.dispatch('setLoading', true)
            const url = `attendance/update/${this.attendanceId}`
            const form = {
                checkin_time: this.form.checkIn,
                checkout_time: this.form.checkOut,
                status: this.form.status
            }

            const res = await this.axios.put(url, form)
            this.checkRespose(res)
        },

        async submit () {
            if (!this.$refs.form.validate()) {
                return
            }
            await this.updateAttendance()
        },

        choiceClass (status, choice) {
            if (status === choice) {
                return `${this.baseChoiceClass} active`
            }
            return this.baseChoiceClass
        },

        checkRespose (res) {
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.attendanceForm.congratulation'),
                    text: res.data.msg,
                    type: 'success'
                })
                this.cancel()
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors

                if ('checkIn' in res.data.errors) {
                    this.messageErrorCheckin = res.data.errors.checkIn
                }

                if ('checkOut' in res.data.errors) {
                    this.messageErrorCheckout = res.data.errors.checkOut
                }

                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.attendanceForm.errorMessage'),
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        }
    },

    async mounted () {
        this.attendanceId = this.$route.params.id
        await this.loadData(this.attendanceId)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.changeTime()
                this.$util.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
}

.pa-attendance-review {
    padding: 40px;
}
.attendance-form-container {
    display: grid;
    min-height: 100%;
    height: 100%;
    margin-bottom: 2rem;
    grid-gap: 25px;
    grid-template-columns: calc(60% - 12.5px) calc(40% - 12.5px);
    color: white;

    .card-header {
        font-size: 24px;
        margin-bottom: 24px !important;
    }

    .status-card-header {
        font-size: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .date-data {
            font-size: 16px;
        }
    }

    .form-label {
        font-size: 14px;
        color: #6c6c6c;
        line-height: 1.29;
        margin-bottom: 5px;

        &:not(:first-child) {
            margin-top: 23px;
        }
    }

    .form-text {
        font-size: 16px;
        line-height: 1.19;
        color: #131410;
    }

}
.attendance-profile {
    grid-column: 1 / 1;
    grid-row: 1 / 3;
}
.attendance-status {
    grid-column: 2 / 2;
    grid-row: 1 / 3;
}
.attendance-log {
    grid-column: 1 / 3;
    grid-row: 4 / 4;
}
.choices-container {
    display: inline-flex;
    padding: 0px 16px;
    font-size: 16px;
    .disable {
        pointer-events: none;
        cursor: not-allowed;
    }

    .choice {
        height: 32px;
        min-width: 80px;
        width: 31%;
        border-top: solid 1px #d76436;
        border-bottom: solid 1px #d76436;
        color: #d76436;

        &:hover {
            background-color: lighten($color: #d76436, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #d76436;
            cursor: default;
            pointer-events: none;
        }
    }

    .choice:first-child {
        color: #6c98ba;
        border: solid 1px #6c98ba;
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;

        &:hover {
            background-color: lighten($color: #6c98ba, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #6c98ba;
        }
    }

    .choice:last-child {
        color: #ff544a;
        border: solid 1px #ff544a;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;

        &:hover {
            background-color: lighten($color: #ff544a, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #ff544a;
        }
    }

}
.late-status {
    color: white;
    background-color: #d76436;
}

.ontime-status {
    color: white;
    background-color: #6c98ba;
}

.absent-status {
    color: white;
    background-color: #ff544a;
}
.no-data {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 40px;
    font-size: 22px;
    font-weight: 500;
    color: #6c6c6c;
}
.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
}
.text-ellipsis-12 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 500px;
}
.time-input-container {
    height: 130px;
}
.custom-scrollbar {
    overflow-y: scroll;
    height: 100vh;
    max-height:500px
}
.custom-scrollbar::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #555;
}

.custom-scrollbar::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #F5F5F5;
}

.content-container {
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    border-radius: 15px !important;
}
</style>
